import { createContext } from "react";
import { SpringValue } from "@react-spring/core";
import { io } from "socket.io-client";

export const OpacityContext = createContext<SpringValue<number>>(new SpringValue(0));


export const socket = io(process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001');

export const SocketContext = createContext(socket);